import { Flex, Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	DataKYCFileTctWithFile,
	GetKYCInvestorInstanceRes,
	KYCFileType,
} from '@dealstack/shared/lib/generated';
import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { FormReviewCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/FormReviewCard';
import { AddKycFileButton } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/AddKycFileButton';

interface Props {
	files: DataKYCFileTctWithFile[];
	currentStep?: Step;
	currentInvestor?: GetKYCInvestorInstanceRes;
	selectedKycFileId?: string;
	onSelectFile?: (file: DataKYCFileTctWithFile) => void;
	isReadOnly?: boolean;
}

export const UncategorizedFilesSection = ({
	files,
	currentStep,
	currentInvestor,
	selectedKycFileId,
	onSelectFile,
	isReadOnly = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex direction="column" gap="0.5rem">
			<Text size="B6Bold" c="dark.8">
				{tMipManage('kyc.review.forms.uncategorized_files')}
			</Text>

			{files.map((file) => (
				<FormReviewCard
					key={file.id}
					primaryText={file.file?.name ?? ''}
					kycFile={file}
					kycHistory={currentInvestor?.kycHistory}
					isSelected={file.id === selectedKycFileId}
					onClick={onSelectFile ? () => onSelectFile(file) : undefined}
				/>
			))}

			{!isReadOnly && (
				<AddKycFileButton
					currentStep={currentStep}
					currentInvestor={currentInvestor}
					typeOverride={KYCFileType.OTHER}
				/>
			)}
		</Flex>
	);
};
